import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-types";

interface MorePaymentOptionsTestIds {
    container: string;
    header: string;
    subtext: string;
    icon: string;
}

const PAYMENT_GROUP_PREFIX = "pg";
const MORE_PAYMENT_OPTIONS_GROUP_PREFIX = `${PAYMENT_GROUP_PREFIX}_mo`;
const NETBANKING_GROUP_PREFIX = `${PAYMENT_GROUP_PREFIX}_nb`;
const OTHER_PAYMENTS_GROUP_PREFIX = `${PAYMENT_GROUP_PREFIX}_op`;
const PREFERRED_GROUP_PREFIX = `${PAYMENT_GROUP_PREFIX}_pref`;
const UPI_METHOD_PREFIX = `${PAYMENT_GROUP_PREFIX}_upi`;
const INAPP_UPI_METHOD_PREFIX = `${PAYMENT_GROUP_PREFIX}_inapp_upi`;
const REWARDS_PREFIX = `${PAYMENT_GROUP_PREFIX}_rewards`;

export const PAYMENT_GROUP_TEST_IDS = {
    CONTAINER: `${PAYMENT_GROUP_PREFIX}_container`,
    TITLE: {
        PREFERRED: `${PREFERRED_GROUP_PREFIX}_title`,
        CARD: `${PAYMENT_GROUP_PREFIX}_card_title`,
        FOOD_CARD: `${PAYMENT_GROUP_PREFIX}_fc_title`,
        COD: `${PAYMENT_GROUP_PREFIX}_cod_title`,
        MORE_PAYMENT_OPTIONS: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_title`,
        NETBANKING: `${NETBANKING_GROUP_PREFIX}_title`,
        OTHER_PAYMENTS: `${OTHER_PAYMENTS_GROUP_PREFIX}_title`,
        PAY_LATER: `${PAYMENT_GROUP_PREFIX}_pl_title`,
        SWIGGY_INSTRUMENTS: `${PAYMENT_GROUP_PREFIX}_si_title`,
        FLIPKART_SUPER_COINS: `${PAYMENT_GROUP_PREFIX}_fk_coins_title`,
        UPI: `${PAYMENT_GROUP_PREFIX}_upi_title`,
        B2C: `${PAYMENT_GROUP_PREFIX}_b2c_title`,
        WALLET: `${PAYMENT_GROUP_PREFIX}_wallet_title`,
        CRED: `${PAYMENT_GROUP_PREFIX}_cred_title`,
        INAPP_UPI: `${INAPP_UPI_METHOD_PREFIX}_title`,
        EMI: `${PAYMENT_GROUP_PREFIX}_emi_title`,
        REWARDS: `${PAYMENT_GROUP_PREFIX}_rewards_title`,
    },
    BANNER_MESSAGE: {
        PREFERRED: `${PAYMENT_GROUP_PREFIX}_pref_bm`,
        CARD: `${PAYMENT_GROUP_PREFIX}_card_bm`,
        FOOD_CARD: `${PAYMENT_GROUP_PREFIX}_fc_bm`,
        COD: `${PAYMENT_GROUP_PREFIX}_cod_bm`,
        MORE_PAYMENT_OPTIONS: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_bm`,
        NETBANKING: `${NETBANKING_GROUP_PREFIX}_bm`,
        OTHER_PAYMENTS: `${OTHER_PAYMENTS_GROUP_PREFIX}_bm`,
        PAY_LATER: `${PAYMENT_GROUP_PREFIX}_pl_bm`,
        SWIGGY_INSTRUMENTS: `${PAYMENT_GROUP_PREFIX}_si_bm`,
        UPI: `${PAYMENT_GROUP_PREFIX}_upi_bm`,
        B2C: `${PAYMENT_GROUP_PREFIX}_b2c_bm`,
        WALLET: `${PAYMENT_GROUP_PREFIX}_wallet_bm`,
        INAPP_UPI: `${INAPP_UPI_METHOD_PREFIX}_bm`,
    },
    NETBANKING: {
        PROMO_MESSAGE: `${NETBANKING_GROUP_PREFIX}_promo_msg`,
        MORE_BANKS_LINK: `${NETBANKING_GROUP_PREFIX}_more_link`,
    },
    OTHER_METHODS: {
        CONTENT: `${OTHER_PAYMENTS_GROUP_PREFIX}_content`,
        CONTENT_MESSAGE: `${OTHER_PAYMENTS_GROUP_PREFIX}_content_msg`,
    },
    PREFERRED: {
        MORE_METHODS_CTA: `${PREFERRED_GROUP_PREFIX}_mmc`,
    },
    UPI: {
        MORE_METHODS_CTA: `${UPI_METHOD_PREFIX}_mmc`,
    },
    INAPP_UPI: {
        MORE_METHODS_CTA: `${INAPP_UPI_METHOD_PREFIX}_mmc`,
    },
    REWARDS: {
        CONTENT: `${REWARDS_PREFIX}_content`,
        VIEW_ALL_REWARDS_CTA: `${REWARDS_PREFIX}_varc`,
    },
};

const VALID_GROUP_ITEM_ID = {
    [VALID_PAYMENT_GROUP_TYPES.CARD]: "card",
    [VALID_PAYMENT_GROUP_TYPES.COD]: "cod",
    [VALID_PAYMENT_GROUP_TYPES.FOOD_CARD]: "fc",
    [VALID_PAYMENT_GROUP_TYPES.NETBANKING]: "nb",
    [VALID_PAYMENT_GROUP_TYPES.PAY_LATER]: "pl",
    [VALID_PAYMENT_GROUP_TYPES.PREFERRED]: "pref",
    [VALID_PAYMENT_GROUP_TYPES.SWIGGY_INSTRUMENTS]: "si",
    [VALID_PAYMENT_GROUP_TYPES.UPI]: "upi",
    [VALID_PAYMENT_GROUP_TYPES.BILL_TO_COMPANY]: "b2c",
    [VALID_PAYMENT_GROUP_TYPES.INAPP_UPI]: "inapp_upi",
    [VALID_PAYMENT_GROUP_TYPES.WALLET]: "wal",
    [VALID_PAYMENT_GROUP_TYPES.WALLET_WEB]: "wal",
    [VALID_PAYMENT_GROUP_TYPES.EMI]: "emi",
};

export const getMorePaymentOptionTestIds = (groupName: string): MorePaymentOptionsTestIds => {
    const suffix = VALID_GROUP_ITEM_ID[groupName] || "other";

    return {
        container: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_${suffix}`,
        header: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_${suffix}_header`,
        subtext: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_${suffix}_subtext`,
        icon: `${MORE_PAYMENT_OPTIONS_GROUP_PREFIX}_${suffix}_icon`,
    };
};
